import PerfectScrollbar from "perfect-scrollbar";

function scrollbarInit(domSelector, config = {}) {
  const dom = document.querySelector(domSelector);

  const ps = new PerfectScrollbar(domSelector, {
    wheelPropagation: true,
  });

  if (config.reachBottom instanceof Function) {
    dom.addEventListener("ps-y-reach-end", () => config.reachBottom());
  }

  return ps;
}

export default scrollbarInit;
